import { render, staticRenderFns } from "./VigilanciaView.vue?vue&type=template&id=51105f59"
import script from "./VigilanciaView.vue?vue&type=script&lang=js"
export * from "./VigilanciaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports